<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <div class="container-fluid">
          <section class="content-header">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-6">
                  <h5 class="mb-0">Solicitudes Vehículos</h5>
                </div>
                <div class="col-sm-6">
                  <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item">
                      <router-link to="/">Home</router-link>
                    </li>
                    <li class="breadcrumb-item">
                      <router-link to="/Hse">Orion</router-link>
                    </li>
                    <li class="breadcrumb-item">
                      <router-link to="/Hse">Solicitud</router-link>
                    </li>
                    <li class="breadcrumb-item active">Vehículos</li>
                  </ol>
                </div>
              </div>
            </div>
          </section>
          <section class="content">
            <div class="container-fluid">
              <div class="card">
                <div class="card-header pt-2 pb-2">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="btn-group float-right">
                        <button
                          type="button"
                          class="btn bg-navy"
                          @click="getIndex()"
                        >
                          <i class="fas fa-sync-alt"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-md bg-danger"
                          @click="back()"
                        >
                          <i class="fas fa-broom"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          v-if="
                            $store.getters.can(
                              'funcionariofrontera.solicitudVehiculo.create'
                            )
                          "
                          @click="create()"
                        >
                          <i class="fas fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body pb-0">
                  <div class="row justify-content-center">
                    <div class="form-group col-md-1">
                      <label># Solicitud</label>
                      <input
                        class="form-control form-control-sm"
                        type="number"
                        v-model="filters.solicitud_id"
                        @input="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-1">
                      <label>Vehículo</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.placa"
                        @input="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label>Marca</label>
                      <v-select
                        class="form-control form-control-sm p-0"
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="marca"
                        placeholder="Marca"
                        label="descripcion"
                        :options="listsForms.marcas"
                        @input="selectMarca()"
                      >
                      </v-select>
                    </div>
                    <div class="form-group col-md-1">
                      <label>Modelo</label>
                      <input
                        type="number"
                        class="form-control form-control-sm"
                        v-model="filters.modelo"
                        @input="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label>Clase Vehículo</label>
                      <v-select
                        class="form-control form-control-sm p-0"
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="clase_vehiculo"
                        placeholder="Clase Vehículo"
                        label="descripcion"
                        :options="listsForms.clases_vehiculos"
                        @input="selectClaseVehiculo()"
                      >
                      </v-select>
                    </div>
                    <div class="form-group col-md-3">
                      <label>Email</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.email"
                        @input="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-5">
                      <label>Empresa</label>
                      <v-select
                        class="form-control form-control-sm p-0"
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="empresa"
                        placeholder="Empresa"
                        label="descripcion"
                        :options="listsForms.empresas"
                        @input="selectEmpresa()"
                      >
                      </v-select>
                    </div>
                    <div class="form-group col-md-3">
                      <label>Área</label>
                      <v-select
                        class="form-control form-control-sm p-0"
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="area"
                        placeholder="Area"
                        label="descripcion"
                        :options="listsForms.areas"
                        @input="selectArea()"
                      >
                      </v-select>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Sitio</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.sitio"
                        @change="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-2">
                      <label>Activo</label>
                      <v-select
                        class="form-control form-control-sm p-0"
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="activo"
                        placeholder="Activo"
                        label="descripcion"
                        :options="listsForms.activos"
                        @input="selectActivo()"
                      >
                      </v-select>
                    </div>
                    <div class="form-group col-md-3">
                      <label>Operación</label>
                      <v-select
                        class="form-control form-control-sm p-0"
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="operacion"
                        placeholder="Operación"
                        label="descripcion"
                        :options="listsForms.operacion_vehiculos"
                        @input="selectOperacion()"
                      >
                      </v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Estado</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="filters.estado"
                        @input="getIndex()"
                      >
                        <option value="">Seleccione...</option>
                        <option
                          v-for="estadoOpc in listsForms.estados"
                          :key="estadoOpc.numeracion"
                          :value="estadoOpc.numeracion"
                        >
                          {{ estadoOpc.descripcion }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="card-body table-responsive p-0">
                  <table
                    style="font-size: 0.85em"
                    class="table table-bordered table-striped table-hover table-sm text-nowrap"
                  >
                    <thead class="text-center bg-dark">
                      <tr>
                        <th># Solicitud</th>
                        <th>Foto</th>
                        <th>Vehículo</th>
                        <th>Email</th>
                        <th class="col-2">Clase Vehículo</th>
                        <th>Modelo</th>
                        <th>Empresa</th>
                        <th>Marca</th>
                        <th>Área</th>
                        <th>Sitio</th>
                        <th>Activo</th>
                        <th>Operación</th>
                        <th>Estado</th>
                        <th>acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="solicitud in solicitudesVehiculos.data"
                        :key="solicitud.data"
                      >
                        <td class="text-center">
                          <button
                            type="button"
                            class="btn btn-sm btn-default py-0"
                            data-toggle="modal"
                            data-target="#modal-form-detalles"
                            @click="modalDetalles(solicitud)"
                          >
                            {{ solicitud.id }}
                          </button>
                        </td>
                        <td>
                          <a
                            v-if="
                              solicitud.link_foto ? solicitud.link_foto : null
                            "
                            :href="uri_docs + solicitud.link_foto"
                            target="_blank"
                          >
                            <img
                              :src="uri_docs + solicitud.link_foto"
                              alt="Vehiculo"
                              width="75"
                              class="rounded mx-auto d-block"
                            />
                          </a>
                        </td>
                        <td class="text-center">
                          {{ solicitud.placa }}
                        </td>
                        <td>{{ solicitud.email }}</td>
                        <td>{{ solicitud.clase_vh }}</td>
                        <td class="text-center">{{ solicitud.modelo }}</td>
                        <td>{{ solicitud.Empresa }}</td>
                        <td>{{ solicitud.Marca }}</td>
                        <td>{{ solicitud.Area }}</td>
                        <td>
                          {{ solicitud.sitios ? solicitud.sitios.nombre : "" }}
                        </td>
                        <td>{{ solicitud.Activo }}</td>
                        <td>{{ solicitud.Operacion }}</td>
                        <td class="text-center">
                          <span
                            class="badge"
                            :class="[
                              solicitud.estado == 1
                                ? 'badge-secondary'
                                : solicitud.estado == 2
                                ? 'badge-success'
                                : solicitud.estado == 3
                                ? 'badge-danger'
                                : solicitud.estado == 4
                                ? 'bg-olive'
                                : solicitud.estado == 5
                                ? 'badge-warning'
                                : solicitud.estado == 6
                                ? 'badge-info'
                                : solicitud.estado == 7
                                ? 'bg-navy'
                                : solicitud.estado == 8
                                ? 'bg-lime'
                                : '',
                            ]"
                            >{{ solicitud.Estado }}</span
                          >
                        </td>
                        <td>
                          <div class="btn-group float-right">
                            <button
                              type="button"
                              class="btn btn-sm bg-navy"
                              @click="edit(solicitud)"
                              v-if="
                                $store.getters.can(
                                  'funcionariofrontera.solicitudVehiculo.edit'
                                )
                              "
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              v-if="
                                solicitud.estado == 4 &&
                                  $store.getters.can(
                                    'funcionariofrontera.solicitudVehiculo.verTarjeton'
                                  )
                              "
                              type="button"
                              class="btn btn-sm btn-success"
                              @click="verTarjeton(solicitud.id)"
                            >
                              <i class="fas fa-wallet"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer">
                  <div class="float-left" v-if="solicitudesVehiculos.total">
                    Mostrando del <b>{{ solicitudesVehiculos.from }}</b> al
                    <b>{{ solicitudesVehiculos.to }}</b> de un total:
                    <b>{{ solicitudesVehiculos.total }}</b> Registros
                  </div>
                  <div class="float-left" v-else>
                    <span class="badge badge-danger">
                      No hay registros para mostrar
                    </span>
                  </div>
                  <pagination
                    :data="solicitudesVehiculos"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    class="float-right m-0"
                  ></pagination>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="modal-form-detalles">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-geogo-top-left pt-2 pb-2">
              <div class="row w-100">
                <div class="col-md-10">
                  <h4 class="modal-title text-white">
                    Solicitud Vehículo : {{ modalDetalle.id }}
                  </h4>
                </div>
                <div class="col-md-2">
                  <button
                    type="button"
                    class="close text-white"
                    data-dismiss="modal"
                    aria-label="Close"
                    ref="closeModal"
                    id="close-modal"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-header pt-2 pb-2">
                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        id="tab-Principal"
                        data-toggle="tab"
                        href="#Principal"
                        >Principal</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="tab-Documentos"
                        data-toggle="tab"
                        href="#Documentos"
                        v-if="modalDetalle.id"
                        >Documentos</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="tab-EstadosHistoricos"
                        data-toggle="tab"
                        href="#EstadosHistoricos"
                        v-if="modalDetalle.id"
                        >Histórico Estados</a
                      >
                    </li>
                  </ul>
                  <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade active show" id="Principal">
                      <div class="card-body">
                        <div class="row">
                          <div
                            class="col-md-6 d-flex align-items-stretch flex-column"
                          >
                            <div
                              class="card card-info card-outline collapsed-card"
                            >
                              <div class="card-header pt-2 pb-2">
                                <h5 class="card-title">
                                  <i class="fa fa-truck text-secondary"></i>
                                  Datos Solicitud Vehículo
                                </h5>
                                <div class="card-tools">
                                  <button
                                    type="button"
                                    data-card-widget="collapse"
                                    data-toggle="tooltip"
                                    title="Collapse"
                                    class="btn btn-tool"
                                  >
                                    <i class="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6"
                                    >Placa:</label
                                  >
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.placa }}
                                  </span>
                                </div>
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6"
                                    >Email:</label
                                  >
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.email }}
                                  </span>
                                </div>
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6">
                                    Activo:
                                  </label>
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.Activo }}
                                  </span>
                                </div>
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6"
                                    >Area:</label
                                  >
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.Area }}
                                  </span>
                                </div>
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6">
                                    Empresa:
                                  </label>
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.Empresa }}
                                  </span>
                                </div>
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6"
                                    >Marca:</label
                                  >
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.Marca }}
                                  </span>
                                </div>
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6">
                                    Operación Vehículo:
                                  </label>
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.Operacion }}
                                  </span>
                                </div>
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6">
                                    Clase Vehículo:
                                  </label>
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.clase_vh }}
                                  </span>
                                </div>
                                <div class="row" v-if="modalDetalle.sitio_id">
                                  <label class="col-md-4 col-sm-4 col-xs-6"
                                    >Sitio:</label
                                  >
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.sitios.nombre }}
                                  </span>
                                </div>
                                <div class="row" v-else>
                                  <label class="col-md-4 col-sm-4 col-xs-6"
                                    >Sitio:</label
                                  >
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  ></span>
                                </div>
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6">
                                    Observaciones:
                                  </label>
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.observaciones }}
                                  </span>
                                </div>
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6">
                                    Estado:
                                  </label>
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.Estado }}
                                  </span>
                                </div>
                                <div
                                  class="row"
                                  v-if="modalDetalle.observaciones_estado"
                                >
                                  <label class="col-md-4 col-sm-4 col-xs-6">
                                    Observaciones Estado:
                                  </label>
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.observaciones_estado }}
                                  </span>
                                </div>
                                <div
                                  class="row"
                                  v-if="modalDetalle.fecha_fin_tarjeton"
                                >
                                  <label class="col-md-4 col-sm-4 col-xs-6">
                                    Fecha Fin Tarjetón:
                                  </label>
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.fecha_fin_tarjeton }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 col-sm-12 col-xs-12">
                            <div
                              class="card card-info card-outline collapsed-card"
                            >
                              <div class="card-header pt-2 pb-2">
                                <h5 class="card-title">
                                  <i
                                    class="fa fa-align-justify text-secondary"
                                  ></i>
                                  Fechas
                                </h5>
                                <div class="card-tools">
                                  <button
                                    type="button"
                                    data-card-widget="collapse"
                                    data-toggle="tooltip"
                                    title="Collapse"
                                    class="btn btn-tool"
                                  >
                                    <i class="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                              <div class="card-body">
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6"
                                    ><b>Fecha Ingreso:</b>
                                  </label>
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.fecha_ingreso }}
                                  </span>
                                </div>
                                <div class="row">
                                  <label class="col-md-4 col-sm-4 col-xs-6">
                                    Fecha Salida:
                                  </label>
                                  <span
                                    class="col-md-8 col-sm-8 col-xs-6 text-right"
                                  >
                                    {{ modalDetalle.fecha_salida }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Documentos  -->
                    <div class="tab-pane" id="Documentos" v-if="form.id">
                      <SolicitudVehiculoDocumento
                        v-if="form.id != null"
                        ref="SolicitudVehiculoDocumento"
                      />
                    </div>
                    <!-- Estados Historicos  -->
                    <div class="tab-pane" id="EstadosHistoricos" v-if="form.id">
                      <SolicitudVehiculoHistoricoEstado
                        v-if="form.id != null"
                        ref="SolicitudVehiculoHistoricoEstado"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.modal-content -->
            <!-- /.card -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Loading from "../../../../components/Loading";
import vSelect from "vue-select";
import SolicitudVehiculoDocumento from "./SolicitudVehiculoDocumento";
import SolicitudVehiculoHistoricoEstado from "./SolicitudVehiculoHistoricoEstado";
//import SolicitudesVehiculosExport from "../solicitudes/SolicitudesVehiculosExport.vue";

export default {
  name: "SolicitudesVehiculosIndex",
  components: {
    vSelect,
    pagination,
    Loading,
    SolicitudVehiculoDocumento,
    SolicitudVehiculoHistoricoEstado,
  },

  data() {
    return {
      cargando: false,
      filters: {
        solicitud_id: null,
        placa: null,
        email: null,
        modelo: null,
        estado: null,
        empresa_id: null,
        activo_id: null,
        clase_vehiculo_id: null,
        marca_id: null,
        area: null,
        operacion_id: null,
        new: true,
      },
      solicitud: null,
      operacion: null,
      empresa: null,
      activo: null,
      clase_vehiculo: null,
      marca: null,
      area: null,
      solicitudesVehiculos: {},
      listsForms: {
        conductores: [],
        empresas: [],
        activos: [],
        tipos_contratos: [],
        categorias_licencias: [],
        clases_vehiculos: [],
        tipo_documentos: [],
        marcas: [],
        areas: [],
        estados: [],
        sitios: [],
        tarjetones: [],
      },
      modal: {
        sitio_id: null,
        sitio: [],
        tarjetones: [],
        tarjeton_id: null,
        solicitud_id: null,
        fecha: null,
      },
      modalDetalle: {},
      form: {
        id: null,
      },
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },

  methods: {
    async getIndex(page = 1) {
      this.cargando = true;
      await axios
        .get("api/funcionariosFrontera/HseSolicitudesVehiculos?page=" + page, {
          params: this.filters,
        })
        .then((response) => {
          this.cargando = false;
          this.solicitudesVehiculos = response.data;
        });
    },

    back() {
      this.clearFilters();
      this.getIndex();
    },

    clearFilters() {
      this.filters = {
        solicitud_id: null,
        placa: null,
        email: null,
        modelo: null,
        estado: null,
        empresa_id: null,
        activo_id: null,
        clase_vehiculo_id: null,
        marca_id: null,
        area: null,
        operacion_id: null,
        new: true,
      };
      this.empresa = null;
      this.activo = null;
      this.clase_vehiculo = null;
      this.marca = null;
      this.area = null;
      this.operacion = null;
    },

    //Obtener Listas
    getEmpresas() {
      axios.get("/api/lista/164").then((response) => {
        this.listsForms.empresas = response.data;
      });
    },

    getActivos() {
      axios.get("/api/lista/117").then((response) => {
        this.listsForms.activos = response.data;
      });
    },

    getOperacionVehiculos() {
      axios.get("/api/lista/167").then((response) => {
        this.listsForms.operacion_vehiculos = response.data;
      });
    },

    getClasesVehiculos() {
      axios.get("/api/lista/163").then((response) => {
        this.listsForms.clases_vehiculos = response.data;
      });
    },

    getMarcas() {
      axios.get("/api/lista/12").then((response) => {
        this.listsForms.marcas = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/175").then((response) => {
        this.listsForms.estados = response.data;
      });
    },

    /* getSitios() {
      axios.get("/api/funcionariosFrontera/listaSitios").then((response) => {
        this.listsForms.sitios = response.data;
      });
    }, */

    getAreas() {
      axios.get("/api/lista/99").then((response) => {
        this.listsForms.areas = response.data;
      });
    },

    //Seleccionar solo ids
    selectEmpresa() {
      this.filters.empresa_id = null;
      if (this.empresa) {
        this.filters.empresa_id = this.empresa.numeracion;
      }
      this.getIndex();
    },

    selectActivo() {
      this.filters.activo_id = null;
      if (this.activo) {
        this.filters.activo_id = this.activo.numeracion;
      }
      this.getIndex();
    },

    selectClaseVehiculo() {
      this.filters.clase_vehiculo_id = null;
      if (this.clase_vehiculo) {
        this.filters.clase_vehiculo_id = this.clase_vehiculo.numeracion;
      }
      this.getIndex();
    },

    selectMarca() {
      this.filters.marca_id = null;
      if (this.marca) {
        this.filters.marca_id = this.marca.numeracion;
      }
      this.getIndex();
    },

    selectArea() {
      this.filters.area = null;
      if (this.area) {
        this.filters.area = this.area.numeracion;
      }
      this.getIndex();
    },

    selectOperacion() {
      this.filters.operacion_id = null;
      if (this.operacion) {
        this.filters.operacion_id = this.operacion.numeracion;
      }
      this.getIndex();
    },

    async modalDetalles(solicitud) {
      this.form.id = null;
      this.modalDetalle = {};
      this.modalDetalle = solicitud;
      this.form.id = solicitud.id;
      if (await this.$refs.SolicitudVehiculoDocumento) {
        await this.$refs.SolicitudVehiculoDocumento.getVehiculo(this.form.id);
      }
    },

    edit(solicitud) {
      return this.$router.push({
        name: "/FuncionariosFrontera/SolicitudesVehiculosForm",
        params: {
          accion: "Editar",
          data_edit: solicitud,
          id: solicitud.id,
        },
      });
    },

    verTarjeton(solicitud) {
      this.cargando = true;
      axios({
        method: "get",
        url:
          "/api/funcionariosFrontera/HseSolicitudesVehiculos/pdf/" + solicitud,
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          window.open(data.url, "_blank");
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    create() {
      return this.$router.push({
        name: "/FuncionariosFrontera/SolicitudesVehiculosForm",
      });
    },
  },

  beforeMount() {
    this.getEmpresas();
    this.getActivos();
    this.getOperacionVehiculos();
    this.getClasesVehiculos();
    this.getMarcas();
    this.getEstados();
    this.getAreas();
    /* this.getSitios(); */
  },

  mounted() {
    this.getIndex();
  },
};
</script>

<style>
.my-custom-scrollbar {
  position: relative;
  height: 200px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>
